/**
 * Ryan O'Dowd
 * 2023-12-30
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, colors, isDarkMode}) => {
  return {
    searchBarWrapper: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 8,
      paddingRight: 8,
      paddingBottom: 8,
      paddingLeft: 8,
    },
    searchBar: {
      flexGrow: 1,
      fontFamily: fonts.primary,
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primaryLight,
      borderWidth: 4,
      borderColor: colors.primary,
      borderRadius: 12,
    },
    searchBarWhite: {
      backgroundColor: isDarkMode ? colors.gray : colors.white,
      borderWidth: 4,
      borderColor: colors.lightGray,
      borderRadius: 12,
    },
  };
};

export default getStyles;
